import { CommonModule, NgStyle } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { ConfigService } from '../../../../my-shared-lib/src/lib/shared-services/config.service';
import { GlobalFilterService } from '../../../../my-shared-lib/src/lib/shared-services/global-filter-service';
import { debounceTime, Subject, Subscription, switchMap, takeUntil } from 'rxjs';
import { formatStat } from '../../../../my-shared-lib/src/lib/utils/format.utils';
import { CustomPayloadService } from '../shared/dashboard-payload-services/custom-payload.service';

@Component({
  selector: 'app-number-stats',
  standalone: true,
  imports: [NgStyle, CommonModule],
  templateUrl: './number-stats.component.html',
  styleUrl: './number-stats.component.scss'
})
export class NumberStatsComponent implements AfterViewInit, OnDestroy {
  @Input() data!: any;
  stat!: string;
  private filterSub!: Subscription;
  private unSubscribe$: Subject<void> = new Subject();

  constructor(
    private configService: CustomPayloadService,
    private globalFilterService: GlobalFilterService
  ) { }

  ngAfterViewInit(): void {
    this.loadStat(); // load initially without filters if any

    this.globalFilterService.filter$
      .pipe(
        takeUntil(this.unSubscribe$),
        switchMap((filters) => this.loadStat(filters))
      )
      .subscribe({
        next: (res: any) => {
          const parent = this.data?.parentKey ? res[this.data?.parentKey] : res;
          const rawValue = parent?.[this.data.key];

          this.stat = this.data?.useFormatStat
            ? formatStat(
                rawValue,
                this.data?.key || '',
                this.data?.prefix || ''
              )
            : rawValue;
        },
        error: (err) => {
          console.error('Error loading stat:', err);
        },
      });
  }
  get formattedTitle(): string {
    return this.data?.title?.replace(/\n/g, '<br>') || '';
  }


  loadStat(filters?: any): any {
    return this.configService.getConfig(this.data?.apiUrl, {
      ...filters,
      useQueryParams: this.data?.useQueryParams || false
    })
  }

  ngOnDestroy(): void {
    this.filterSub?.unsubscribe();
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }
}
